import { useMemoSelector } from 'hooks';
import { getIsOpenSidebar } from 'store';

import { ReactComponent as CloseIcon } from 'assets/close-2.svg';
import { ReactComponent as SidebarSvg } from 'assets/sidebar.svg';

const SidebarIcon = () => {
  const isOpenSidebar = useMemoSelector(getIsOpenSidebar);

  return isOpenSidebar ? <CloseIcon /> : <SidebarSvg />;
};

export default SidebarIcon;
